import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SeoHead } from "@/components/seo/SeoHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <SeoHead title="Página não encontrada | FabChat" noindex />
      <div className="text-center max-w-md px-4">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-gray-600">
          Esta página não existe no site da FabChat.
        </p>
        <p className="mb-6 text-sm text-gray-600">
          Agentes e integrações: consulte{" "}
          <a href="/llms.txt" className="text-blue-600 underline hover:text-blue-800">
            llms.txt
          </a>
          , o{" "}
          <a href="/sitemap.xml" className="text-blue-600 underline hover:text-blue-800">
            sitemap
          </a>{" "}
          ou o{" "}
          <Link to="/llm" className="text-blue-600 underline hover:text-blue-800">
            resumo do produto para IA
          </Link>
          .
        </p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Voltar à página inicial
        </a>
      </div>
    </div>
  );
};

export default NotFound;
